module.exports = __webpack_public_path__ + "img/whatsapp.0e11c4be.svg";